import { SelectValue } from '../../../Components/Base/Select/Select';
import { TermItem } from '../../../graphql/graphql';
import { CSSZEmployment } from '../Interfaces/CSSZ.interface';

const EMPLOYER_ADDRESS_TYPE: SelectValue = {
	label: 'Zaměstnavatel',
	value: 'employer',
};

export function hasInsuranceAdministratorAddressForEmployment(
	data: InsuranceAdministratorTermData | null | undefined,
): boolean {
	return Boolean(data?.address?.countryTermId);
}

export function insuranceAdministratorNeedsManualProfession(
	data: InsuranceAdministratorTermData | null | undefined,
): boolean {
	return Boolean(
		hasInsuranceAdministratorAddressForEmployment(data) &&
			!String(data?.profession ?? '').trim(),
	);
}

export type InsuranceAdministratorTermData = {
	name?: string;
	profession?: string;
	address?: {
		city: string;
		street?: string;
		postCode: string;
		guideNumber?: string;
		descriptiveNumber: string;
		countryTermId: string;
		partOfCity?: string;
		floor?: string;
		note?: string;
	};
};

export function buildEmploymentFromInsuranceAdministratorTermItem(
	termItem: TermItem,
	data: InsuranceAdministratorTermData,
	countryTermItem: { id: string; name?: string | null },
): CSSZEmployment {
	const addr = data.address!;
	const state: SelectValue = {
		value: countryTermItem.id,
		label: countryTermItem.name ?? '',
	};

	return {
		employer: data.name ?? termItem.name ?? '',
		profession: data.profession ?? '',
		address: {
			street: addr.street,
			descriptiveNumber: addr.descriptiveNumber,
			guideNumber: addr.guideNumber,
			postCode: addr.postCode,
			city: addr.city,
			partOfCity: addr.partOfCity,
			floor: addr.floor,
			note: addr.note,
			state,
			typeOfAddress: EMPLOYER_ADDRESS_TYPE,
		},
	};
}
